import { CmsApplianceDetailsModelSerialConfirmation } from '../../models/appliance-details-model-serial/cms-appliance-details-model-serial-confirmation.interface';

export const mockCmsApplianceDetailsModelSerialConfirmation: CmsApplianceDetailsModelSerialConfirmation =
  {
    title: 'title',
    body: '<p>body</p>',
  };
